export const getPageType = (page) => {
    let pageType = 'other';

    if (page?.match(/home/)) {
        pageType = 'home-page';
    } else if (page?.match(/product/)) {
        pageType = 'product-page';
    } else if (page?.match(/category/)) {
        pageType = 'category-page';
    } else if (page?.match(/cart/)) {
        pageType = 'cart-page';
    } else if (page?.match(/checkout/)) {
        pageType = 'checkout-page';
    }

    return pageType;
};

export default {

};
